export const UPDATE_WINDOW = 'UPDATE_WINDOW';

export const updateWindow = props => {
    return {
        type: UPDATE_WINDOW,
        ...props
    }
};
